import React from "react"
import '../../assets/scss/purpleTheme/components/card.scss'

const CardItem = (props) => {
  return(
    <div className={`carditem ${props.className}`} style={{backgroundColor:`${props.bgColor}`, cursor:`${props.cursor}`, border:`${props.border}`}}>
      {props.children}
    </div>
  )
}

export default CardItem;